import { render, staticRenderFns } from "./modelRoofItemData.vue?vue&type=template&id=4bc28b37&scoped=true&"
import script from "./modelRoofItemData.vue?vue&type=script&lang=js&"
export * from "./modelRoofItemData.vue?vue&type=script&lang=js&"
import style0 from "./modelRoofItemData.vue?vue&type=style&index=0&id=4bc28b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc28b37",
  null
  
)

export default component.exports